// extracted by mini-css-extract-plugin
export default {"battery":"DeviceBatteryLevel_battery__WFqV2","battery_icon":"DeviceBatteryLevel_battery_icon__0eVRI"};